import PageHeader from './PageHeader';

export default PageHeader;
export type { PageHeaderProps } from './PageHeader';
